
export function clientLanguagesData(): Record<string, { name: string; flag: string }> {
  const clientFlowLanguages = window.ENV.CLIENT_LANGUAGES.filter(lang => lang)
  const available = languageConfigOptions()
  return clientFlowLanguages.reduce((obj, lang) => {
    obj[lang] = available[lang]
    return obj
  }, {});
};

export function languageConfigOptions(): Record<string, { name: string; flag: string }> {
  // Keep in sync with config/application.rb config.i18n.available_locales
  return {
    en: { name: 'English', flag: '🇬🇧' },
    cy: { name: 'Welsh', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿' },
    de: { name: 'German', flag: '🇩🇪' },
    fr: { name: 'French', flag: '🇫🇷' },
    es: { name: 'Spanish', flag: '🇪🇸' },
    it: { name: 'Italian', flag: '🇮🇹' },
    nl: { name: 'Dutch', flag: '🇳🇱' },
    sv: { name: 'Swedish', flag: '🇸🇪' }
  }
}
